// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "list-16vIY";
export { _1 as "__esModule", _2 as "list" }
export default { "__esModule": _1, "list": _2 }
